import React from 'react';

import { EmpresaFiscal } from '../../../services/ativarEmissaoService';
import * as S from '../styles';

interface Step1Props {
  company: EmpresaFiscal | null;
  missing: string[];
}

/** 12345678000199 → 12.345.678/0001-99 (só exibição). */
const formatCnpj = (value?: string | null): string => {
  const digits = (value || '').replace(/\D/g, '');
  if (digits.length !== 14) return value || '—';
  return digits.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    '$1.$2.$3/$4-$5',
  );
};

const ambienteLabel = (value?: string | null): string => {
  if (String(value) === '1') return 'Produção';
  if (String(value) === '2') return 'Homologação';
  return '—';
};

/**
 * Passo 1 — Dados fiscais (Story 1-7 / AC9). Resume e valida os campos fiscais
 * da empresa (criados na Story 1-4). NÃO edita aqui: a edição é na aba Fiscal
 * (T1.37). Se faltar campo obrigatório, orienta a completá-lo antes de avançar.
 */
const Step1DadosFiscais: React.FC<Step1Props> = ({ company, missing }) => {
  const endereco = company?.endereco || {};

  return (
    <S.StepCard>
      <h3>1. Dados fiscais</h3>

      {missing.length > 0 && (
        <S.Warning>
          Para ativar a emissão, complete os dados fiscais na aba{' '}
          <strong>Configurações → Fiscal</strong> da empresa. Pendências:
          <ul>
            {missing.map((field) => (
              <li key={field}>{field}</li>
            ))}
          </ul>
        </S.Warning>
      )}

      <S.SummaryGrid>
        <div className="item">
          <span className="label">CNPJ</span>
          <span className="value">{formatCnpj(company?.cnpj_cpf)}</span>
        </div>
        <div className="item">
          <span className="label">Inscrição Estadual</span>
          <span className="value">{company?.inscricao_estadual || '—'}</span>
        </div>
        <div className="item">
          <span className="label">Código município (IBGE)</span>
          <span className="value">{company?.codigo_municipio_ibge || '—'}</span>
        </div>
        <div className="item">
          <span className="label">Regime tributário</span>
          <span className="value">{company?.regime_tributario_id || '—'}</span>
        </div>
        <div className="item">
          <span className="label">Endereço</span>
          <span className="value">
            {endereco.logradouro
              ? `${endereco.logradouro}, ${endereco.cidade || ''}/${
                  endereco.estado || ''
                }`
              : '—'}
          </span>
        </div>
        <div className="item">
          <span className="label">Ambiente fiscal</span>
          <span className="value">{ambienteLabel(company?.ambiente_fiscal)}</span>
        </div>
      </S.SummaryGrid>
    </S.StepCard>
  );
};

export default Step1DadosFiscais;
